import { useTranslation } from 'react-i18next';

import { LearningType, LearningTypeLabel } from '@/ui/Label';
import { LearningItemType } from '@/features/journey/admin/hooks/useLazyLearningItems';

const formatLabelLearningType = (learningType: string) => {
  switch (learningType) {
    case 'practicalAssessment':
      return 'PRACTICAL_ASSESSMENT';
    case 'liveEvent':
      return 'LIVE_EVENT';
    case 'onlineLearning':
      return 'ONLINE_LEARNING';
    case 'eLearning':
      return 'E_LEARNING';
    default:
      return learningType?.replace('-', '_')?.toLocaleUpperCase();
  }
};

export const JourneyInsightsTabsLearningItemsTypeFormatter = ({ row: { type } }: { row: LearningItemType }): JSX.Element => {
  const { t } = useTranslation('productType');

  return (
    <>
      <LearningTypeLabel text={t(type)} type={formatLabelLearningType(type) as LearningType} />
    </>
  );
};
